import { FC } from 'react';

import { usePathname } from 'expo-router';
import { Alert } from 'react-native';

import { useRumPageView } from 'hooks/rum/use-rum-page-view';
import useEffectOnce from 'hooks/use-effect-once';
import { useDismissAndReplace } from 'navigation/hooks/use-dismiss-and-navigate';
import { CustomEventNames, EventTypes, logEvent } from 'state/amplitude';
import logger from 'utils/logger';
import { routes } from 'utils/routing';

const NotFound: FC = () => {
  useRumPageView('not-found', 'Not Found');
  const pathname = usePathname();

  const dismissAndReplace = useDismissAndReplace();

  useEffectOnce(() => {
    logEvent(CustomEventNames.PAGE_NOT_FOUND, EventTypes.Other, {
      path: pathname,
    });
    logger.warn({ message: '404 - Not Found, redirecting to home', attemptedPathname: pathname });

    if (__DEV__) {
      Alert.alert('404 - Not Found', `Path: ${pathname}`);
    }

    dismissAndReplace(routes.base);
  });
  return null;
};

export default NotFound;
